import { render, staticRenderFns } from "./bsTrends.vue?vue&type=template&id=1f09541e&"
import script from "./bsTrends.vue?vue&type=script&lang=js&"
export * from "./bsTrends.vue?vue&type=script&lang=js&"
import style0 from "./bsTrends.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports